import React from 'react';
import { Form, Col, Row, Button, Spinner, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import moment from 'moment';
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import ReactGA from "react-ga4"

class ViewServiceRequest extends React.Component {
    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null);
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            request: props.location.state.request,
            requestEquipment: [],
            requestContacts: [],
            errors: {},
            completeText: 'Enter K2A Service Call ID:',
            rejectText: 'Enter rejection reason:',
            modalText: 'Enter K2A Service Call ID:',
            isCompletion: true,
            showModal: false,
            loading: false,
            submitValue:''
        };

        this.showButton = this.showButton.bind(this);

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.getEquipment = this.getEquipment.bind(this);


        this.completeRequest = this.completeRequest.bind(this);
        this.rejectRequest = this.rejectRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    componentDidMount() {
        this.getEquipment();
        var contacts = [
            {
                Type: 'Requestor',
                Name: this.state.request.RequestorFirstName + " " + this.state.request.RequestorLastName,
                Email: this.state.request.RequestorEmail,
                Phone: this.state.request.RequestorPhone,
            }, {
                Type: 'Service POC',
                Name: this.state.request.SPoCFirstName + " " + this.state.request.SPoCLastName,
                Email: this.state.request.SPoCEmail,
                Phone: this.state.request.SPoCPhone,
            }, {
                Type: 'Billing POC',
                Name: this.state.request.BillToPoCFirstName + " " + this.state.request.BillToPoCLastName,
                Email: this.state.request.BillToPoCEmail,
                Phone: this.state.request.BillToPoCPhone,
            }
        ];
        this.setState({requestContacts:contacts});
    }
    handleTableChange() { }
    getEquipment() {
        axios.get(`${Constants.apiURL}/api/Request/GetServiceRequestEquipment`, {
            params: {
                user: this.state.user.username,
                requestID: this.state.request.PortalServiceRequestKey
            }
        }).then(response => {
            console.log(response);
            if (response.data) {

                this.setState(() => ({
                    requestEquipment: response.data
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }

    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;
        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ marginLeft: '10px', backgroundColor: '#1F419B' }} variant="primary" type="submit">
                Submit
            </Button>
        }
    }
    componentDidUpdate(event) {
        if (event.history.location.state && event.location.state.typeofrequest != event.history.location.state.typeofrequest) {
            let input = this.state.input;
            input.typeOfRequest = event.history.location.state.typeofrequest;
            this.setState({ input: input });
        }
    }
    completeRequest() {
        this.setState({
            modalText: this.state.completeText,
            isCompletion: true,
            showModal: true
        });
    }
    rejectRequest() {
        this.setState({
            modalText: this.state.rejectText,
            isCompletion: false,
            showModal: true
        });
    }

    handleSubmit() {
        var url = `${Constants.apiURL}/api/Request/` + (this.state.isCompletion ? 'ConfirmServiceRequest' : 'RejectServiceRequest');
        console.log(url);
        axios.get(url, {
            params: {
                user: this.state.user.username,
                requestID: this.state.request.PortalServiceRequestKey,
                value: this.state.submitValue
            }
        }).then(response => {
            if (response.data == true) {
                this.props.history.push({
                    pathname: '/concierge_main',
                    state: {
                        user: this.state.user
                    }
                });
            }
            else {
                alert(response.data);
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response], showModal:false })
            alert('Failed to complete/reject service request.');
            console.log('request failed', response)
        });
    }
    handleClose() {
        this.setState({ showModal: false });
    }
    handleValueChange(event) {
        console.log(event.target);
        this.setState({
            submitValue: event.target.value
        });
    }

    render() {
        const equipmentColumns = [
            {
                text: 'Equipment Type',
                dataField: 'EquipmentType',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left' };
                }
            },
            {
                text: 'Serial #',
                dataField: 'SerialNumber',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left' };
                }
            },
            {
                text: 'Manufacturer',
                dataField: 'Manufacturer',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Model',
                dataField: 'ModelNumber',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            }];
        const contactColumns = [
            {
                text: 'POC Type',
                dataField: 'Type',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left' };
                }
            },
            {
                text: 'Name',
                dataField: 'Name',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left' };
                }
            },
            {
                text: 'Email',
                dataField: 'Email',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Phone Number',
                dataField: 'Phone',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            }];

        const { requestEquipment, showModal, requestContacts } = this.state;
        return (
            <div>
                <Modal ref={this.confirmModal} show={showModal} onHide={this.handleClose}>
                    <Modal.Header closeButton style={{ backgroundColor: '#1F419B', color: '#FFFFFF' }}>
                        <Modal.Title>Confirm</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Label>{this.state.modalText}</Form.Label>
                        <Form.Control name="submitValue" value={this.state.submitValue} onChange={this.handleValueChange} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" name="cancel" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" name="confirm" onClick={this.handleSubmit} disabled={this.state.submitValue == ''}>
                            Confirm
                        </Button>
                    </Modal.Footer>
                </Modal>
                {(this.state.userExists ? <SiteMenu user={this.state.user} currentPage='conciergeViewRequest' /> : <GuestSiteMenu currentPage='conciergeViewRequest' />)}
                <Form onSubmit={this.handleSubmit} noValidate >
                    <Form.Label style={{ paddingBottom: 0, marginBottom: 0, paddingLeft:'10px', verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'fit-content' }}>SERVICE REQUEST DETAILS</Form.Label>
                    <Row className="form-row-first">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formFirstname" >
                                <Form.Label>Company name</Form.Label>
                                <Form.Control disabled type="input" name="companyName" value={this.state.request.Company} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Bill-To Account #</Form.Label>
                                <Form.Control disabled name="BillToAccountID" value={this.state.request.BillToAccountID} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Property Name</Form.Label>
                                <Form.Control disabled name="BuildingName" value={this.state.request.BuildingName} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Address</Form.Label>
                                <Form.Control disabled name="propertyAddress" value={this.state.request.Address1 + (this.state.request.Address2 == null ? "" : ", " + this.state.request.Address2) + ", " + this.state.request.City + ", " + this.state.request.State + " " + this.state.request.Zip}/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md>
                            <Form.Group className="mb-3" controlId="formPhoneNumber">
                                <Form.Label>Purchase Order #</Form.Label>
                                <Form.Control disabled name="poNumber" value={this.state.request.PurchaseOrder} />
                            </Form.Group>
                        </Col>
                        <Col md>
                            <Form.Group className="mb-3" controlId="WorkOrder">
                                <Form.Label>Work Order #</Form.Label>
                                <Form.Control disabled name="workOrder" value={this.state.request.WorkOrder} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="form-row-secondary">
                        <Col md={6}>
                            <Form.Group className="mb-3" controlId="formLastname">
                                <Form.Label>Request Urgency</Form.Label>
                                <Form.Control disabled type="input" name="requestUrgency" value={this.state.request.RequestUrgency} />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Col md={8}>
                        <Form.Group style={{ marginLeft: 10, marginTop: -10, marginRight: 10 }} className="mb-3" controlId="formComments">
                            <Form.Label>Request Description</Form.Label>
                            <Form.Control disabled as="textarea" rows={6} name="comments" value={this.state.request.ServiceRequestText} />
                        </Form.Group>
                    </Col>
                </Form>
                <BootstrapTable
                    remote
                    id="service_request_equipment"
                    keyField="PortalServiceRequestEquipmentKey"
                    data={requestEquipment}
                    columns={equipmentColumns}
                    onTableChange={this.handleTableChange}
                    noDataIndication={() => <Form.Label>No equipment submitted.</Form.Label>}
                    hover
                />
                <BootstrapTable
                    remote
                    id="service_request_contacts"
                    keyField="POCType"
                    data={requestContacts}
                    columns={contactColumns}
                    onTableChange={this.handleTableChange}
                    noDataIndication={() => <Form.Label>No contacts submitted.</Form.Label>}
                    hover
                />
                <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 10px 10px', marginRight: 0 }}>
                    <Col md="auto" sm="auto" xs="auto">
                        <Button style={{ backgroundColor: '#00973A', marginRight: '10px' }} variant="primary" type="submit" onClick={this.completeRequest}>
                            Complete Request
                        </Button>
                        <Button style={{ backgroundColor: 'red', marginRight: '10px' }} variant="primary" type="submit" onClick={this.rejectRequest}>
                            Reject Request
                        </Button>
                    </Col>
                </Form.Group>
            </div>
        );
    }
}

export default ViewServiceRequest;